// src/components/Benefits.js
import React from "react";

const Benefits = ({ id }) => (
  <section id={id} style={styles.section}>
    <h2 style={styles.heading}>
      Beneficios de trabajar con Diversidad, Equidad e Inclusión
    </h2>
    <p style={styles.subheading}>(Inclusion Index 2023)</p>
    <p style={styles.text}>
      Múltiples estudios muestran que entre más diversos sean los equipos,
      generan más innovación y mejor desempeño.
    </p>
    <ul style={styles.list}>
      <li style={styles.listItem}>
        65% de las personas creen que las empresas tienen la responsabilidad de
        hacer una sociedad más justa.
      </li>
      <li style={styles.listItem}>
        49% de las personas entrevistadas en Estados Unidos concuerdan en que es
        importante que las compañías en las que consumen promuevan la diversidad
        e inclusión en su propia empresa o en la sociedad como un todo.
      </li>
    </ul>
  </section>
);

const styles = {
  section: {
    padding: "20px",
    fontFamily: "Outfit, serif",
    fontSize: "2rem",
    fontWeight: "250",
  },
  heading: {
    fontFamily: "Outfit, sans-serif",
    color: "#AC4896",
    fontSize: "3rem",
    marginBottom: "-10px",
    textAlign: "right",
  },
  subheading: {
    textAlign: "right",
    color: "#16C4C0",
    marginTop: "-10px",
    marginBottom: "90px",
  },
  text: {
    marginBottom: "45px",
  },
  list: {
    paddingLeft: "0",
  },
  listItem: {
    marginBottom: "45px",
    listStyle: "none",
    textAlign: "justify",
  },
};

export default Benefits;
